<template>
      <div no-body class="lku-charges"> 
      <b-row v-if="lkuLoading" class="justify-content-center mb-2"><span style="color:blue;">Loading data ...</span></b-row>
      <b-row v-else>
        <b-col cols="10">
          <b-form-group horizontal label="Filter" label-cols="1" >
            <b-form-row>
              <b-col cols="6">
                  <b-form-input v-model="tblData.crewname" placeholder="Employee Name" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
              <b-col cols="6">
                  <b-form-input v-model="tblData.crewnik" placeholder="Employee ID" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
            </b-form-row>
          </b-form-group>
          <b-form-group horizontal  label-cols="1" >
            <b-form-row>
              <b-col cols="6">
                  <b-form-input v-model="tblData.jabatan" placeholder="Job Title" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
              <b-col cols="6">
                  <b-form-input v-model="tblData.departemen" placeholder="Department" @keyup.13.native="refresh()"></b-form-input>
              </b-col>
            </b-form-row>
          </b-form-group>
          </b-col>
      </b-row>
        <b-table
          class="mb-0"
          ref="tblCrew"
          responsive
          striped hover
          :items="data"
          :fields="fields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit" 
          @row-clicked="selectItem"
        >
        </b-table>
        <b-row class="mt-2">
          <b-col cols="6">{{showingLabel}}</b-col>
          <b-col cols="6">
            <b-pagination
              align="right"
              :total-rows="tblData.total"
              :per-page="tblData.limit"
              v-model="tblData.page"
            ></b-pagination>
          </b-col>
        </b-row>
      </div>
</template>
<style lang="scss">
  .lku-charges {
    td {
      padding: 0;

      a {
        //   border: 1px solid;
        text-decoration: none;
        display: block;
        padding: 0.5rem 0.75rem;
      }
    }
  }
</style>

<script>
import crew from "../../apis/crewhr";

export default {
  data() {
    return {
      fields: [
          { key: "crewnik" , 
            label: "Employee ID",
            sortable: true
          },
          { key: "crewname" , 
            label: "Employee Name",
            sortable: true
          },
          {
            key: "jabatan",
            label: "Job Title",
          },
          {
            key: "projectname",
            label: "Project",
            sortable: true
          },
          {
            key: "pangkat",
            label: "Position",
            sortable: true
          },
          {
            key: "departemen",
            label: "Department",
            sortable: true
          },
      ],
      tblData: {
        page: 1,
        limit: 20,
        total: 0,
        sortBy: null,
        sortDesc: false,terminate:0
      },
      lkuLoading:false
    };
  },
  computed: {
    showingLabel() {
      const { tblData } = this;
      const { page, limit, total } = tblData;

      const val1 = (page - 1) * limit + 1;
      const val2 = page * limit < total ? page * limit : total;
      return `Showing ${val1} to ${val2} of ${total} entries`;
    },
  },
  props: ["compcode"],
  // created: async function() {
  //     this.$emit('update:compcode', this.$store.state.user.compcode);
  // },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
    },
    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
      this.tblData.compcode=this.compcode;
      this.lkuLoading=true;
      const list = await crew.list(this.tblData);      
      this.lkuLoading=false;
      return list;
    },
    selectItem(item,index) {
      // 'item' will be the row data from items
      // `index` will be the visible row number (available in the v-model 'shownItems')
      this.$emit("click", item);
    },
    clearFilter() {
        this.tblData={crewnik:'', crewname: '', jabatan: '', department: ''};
        this.refresh();
    },    
    keymonitor: function(event) {
        console.log(event.key);
       if(event.key == "Enter")
       {
        //  console.log('the id of the input was:' + event.currentTarget.id);
        this.$refs.tblCrew.refresh();
       }
    },    
    refresh() {
      this.$refs.tblCrew.refresh();
    }
  }
};
</script>
